// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"7375b67f","737":"642c2b53","787":"70bed51b"}[chunkId] + ".chunk.js";
};